<template lang="pug">

  a.add-product-button(v-if="product", href="#", @click.prevent="click")
    slot
      .cost-value ${{ product.price }}
      template(v-if="product.bonus")
        .bonus-value +${{ product.bonus }}
        .bonus-text If you load your card with ${{ product.price }}, get an extra ${{ product.bonus }}

</template>

<script>
import ProductService from '../services/product';

export default {
  name: 'add-product-button',

  props: ['id'],

  data: () => ({
    product: null
  }),

  async created() {
    const product = await ProductService.get(this.id);
    this.product = {
      price: Number(product.data.price),
      bonus: Number(product.data.balance.bonus_cash)
    };
  },

  methods: {
    click () {
      this.$store.dispatch('addProduct', { productId: this.id, quantity: 1 });
      this.$router.push({ name: 'playcards.buy' });
    }
  }
}
</script>
